module.exports = __webpack_public_path__ + "media/images/sort-direction-desc-b35f23573a6836f031a48bdb30c90855.svg";